/**
 * Hungarian — every string this portal says.
 *
 * Translated from the Slovenian original, which is the source of truth for the
 * vocabulary: the words for a stamp, a shift, a change to one and a decision about
 * leave are the words the rest of this product uses, and a second wording would be a
 * second feature as far as anybody comparing two screens is concerned.
 */
export default {
    app: {
        name: "Munkatársak",
    },
    errors: {
        conflict: "A bejegyzés már létezik vagy foglalt",
        generic_error: "Hiba történt",
        invalid_data: "Érvénytelen adatok",
        module_not_licensed: "Ez a modul nincs bekapcsolva ennél a szállodánál",
        not_found: "Nem található",
        on_add: "Hiba a hozzáadáskor",
        on_edit: "Hiba a módosításkor",
        on_load: "Hiba a betöltéskor",
        operation_in_progress: "Ez a bélyegzés már rögzítés alatt van. Ne nyomd meg újra — egy pillanat múlva látni fogod.",
        operation_mismatch: "A képernyő elavult. Frissítsd az oldalt, és próbáld újra.",
        session_expired: "A munkamenet lejárt. Jelentkezz be újra — semmi nem történt.",
        staff_break_recording_off: "A ház nem rögzíti a szüneteket.",
        staff_not_employed: "Arra a napra nincs érvényes személyi lapod, ezért a bélyegzés nem rögzíthető. Szólj a vezetődnek vagy a személyzeti osztálynak.",
        staff_time_busy: "A bélyegzés rögzítés alatt van. Próbáld újra egy pillanat múlva.",
        staff_time_month_closed: "Ez a hónap le van zárva, és többé nem módosítható. Ha valami nem stimmel, szólj a vezetődnek — újranyitni csak a személyzeti osztály tudja.",
        staff_time_out_of_range: "A bélyegzés ideje kívül esik a megengedett időablakon.",
        staff_time_sequence: "A bélyegzések sorrendje így nem lehetséges (például érkezés egy már nyitott napra).",
        unauthorized: "Nincs jogosultságod ehhez",
    },
    general: {
        hint: 'Tipp',
        cancel: "Mégse",
        hide_password: "Jelszó elrejtése",
        save: "Mentés",
        show_password: "Jelszó megjelenítése",
    },
    home: {
        needs_you: "A válaszodra vár",
        no_shift_today: "Mára nincs közzétett műszak.",
        open_clock: "Minden bélyegzés",
        waiting_on_others: "A ház válaszára vár",
    },
    license: {
        contact: "A bekapcsoláshoz fordulj a rendszergazdához. A ház adatai érintetlenek maradnak.",
        lead: "A „Munkatársak és munkaidő” modul nem része a ház előfizetésének, ezért ez a portál nem tud semmit megmutatni.",
        switch_account: "Jelentkezz be másik fiókkal",
        title: "Ez a szolgáltatás nincs bekapcsolva",
    },
    login: {
        demo_signing_in: "Bejelentkezés …",
        demo_failed: "Ezen a szerveren nincs ilyen szerepkör.",
        failed: "Hibás felhasználónév vagy jelszó",
        password: "Jelszó",
        remember: "Maradj bejelentkezve",
        remember_hint: "A saját telefonodon. Idegen készüléken inkább ne maradj tartósan bejelentkezve.",
        same_account: "Ugyanazzal a felhasználónévvel és jelszóval jelentkezz be, mint a PMS-be. A jelszót itt nem lehet visszaállítani — ehhez fordulj a rendszergazdához.",
        submit: "Bejelentkezés",
        subtitle: "A saját órám, a beosztásom, a szabadságom és a dokumentumaim.",
        title: "Bejelentkezés",
        username: "Felhasználónév",
    },
    nav: {
        account: "Fiók",
        clock: "Óra",
        documents: "Dokumentumok",
        home: "Kezdőlap",
        language: "Nyelv",
        language_de: "Deutsch",
        language_en: "English",
        language_hr: "Hrvatski",
        language_hu: "Magyar",
        language_it: "Italiano",
        language_sl: "Slovenščina",
        leave: "Szabadság",
        logout: "Kijelentkezés",
        profile: "A profilom",
        rota: "Beosztás",
        theme: "Megjelenés",
        theme_dark: "Sötét",
        theme_light: "Világos",
        theme_system: "Rendszer szerint",
    },
    notifications: {
        channel_email: "E-mail",
        channel_email_hint: "Szükség van az e-mail-címedre.",
        channel_messaging: "Üzenetküldő alkalmazások",
        channel_messaging_hint: "Szükség van a WhatsApp-számodra vagy a hozzád kapcsolt Viberre.",
        channel_push: "Alkalmazás a telefonon",
        channel_push_hint: "Szükség van hozzád rendelt céges telefonra vagy órára.",
        channel_sms: "SMS",
        channel_sms_hint: "Szükség van a telefonszámodra.",
    },
    profile: {
        account_hint: "Ki vagy a rendszerben.",
        account_managed_elsewhere: "A nevedet, a felhasználónevedet és a jelszavadat a rendszergazda kezeli. Itt nem módosíthatók.",
        account_title: "Fiók",
        card_hint: "Mit tart nyilván a ház a munkádról.",
        card_read_only: "A személyi lapot a személyzeti osztály kezeli. Ha valami nem stimmel, szólj nekik — a javítás új lap, nem a régi átírása.",
        card_title: "A személyi lapom",
        channel_unavailable: "A ház ezt az utat (még) nem állította be.",
        channels: "Értesítési utak",
        channels_hint: "Ha semmit sem választasz, minden út érvényes, amivel a ház rendelkezik. A szürke út azt jelenti, hogy a ház nem állította be.",
        contact_hint: "Hová küldje a ház a beosztásról szóló értesítést. Ezek az adatok a tieid, és magad szerkeszted őket.",
        contact_title: "Az értesítési adataim",
        department: "Részleg",
        email: "E-mail-cím",
        email_hint: "Ide érkezik az értesítés a beosztás közzétételéről és a műszak változásáról.",
        employee_no: "Törzsszám",
        engagement: "Jogalap",
        hours_per_week: "{hours} óra hetente",
        language_hint: "Erre az eszközre vonatkozik. A fiókod nyelvét a személyzeti osztály állítja be, és az dönti el, milyen nyelven nyílik meg a portál először.",
        manager: "Felettes",
        name: "Név",
        no_card: "Mára nincs érvényes személyi lap.",
        no_card_hint: "Ez az első napon vagy két szezon között megszokott. Ha dolgozol, szólj a személyzeti osztálynak.",
        period: "Időszak",
        period_from: "ettől: {date}",
        phone: "Telefon",
        phone_hint: "Nemzetközi alakban: +38641123456.",
        phone_invalid: "A telefonszámnak +386… alakúnak kell lennie (8–15 számjegy).",
        position: "Munkakör",
        property: "Ház",
        saved: "Mentve.",
        time_record: "Munkaidő-nyilvántartás",
        time_record_not_required: "Nem kötelező",
        username: "Felhasználónév",
        weekly_obligation: "Heti kötelező óraszám",
        work_pattern: "Elosztás a hét napjaira",
        working_time: "Munkaidő",
    },
    staff: {
        acknowledge: "Tudomásul veszem",
        acknowledge_failed: "A visszaigazolást nem sikerült rögzíteni.",
        acknowledge_hint: "A visszaigazolással a nyilvántartásba kerül, hogy láttad a változást, és mikor. Amíg nem igazolod vissza, a beosztást készítő azt látja, hogy még nem tudsz róla.",
        acknowledged: "Átvétel visszaigazolva",
        basis_agency_worker: "Kölcsönzött munkavállaló",
        basis_copyright_contract: "Szerzői jogi szerződés",
        basis_employment_contract: "Munkaszerződés",
        basis_other: "Egyéb jogalap",
        basis_pensioner_temporary: "Nyugdíjas alkalmi munkája",
        basis_self_employed: "Önálló vállalkozó",
        basis_service_contract: "Megbízási szerződés",
        basis_short_term_family_work: "Rövid távú családi munkavégzés",
        basis_student_work: "Diákmunka",
        basis_traineeship: "Szakmai gyakorlat vagy tanulószerződés",
        break_of: "szünet {minutes}",
        change_changed_at: "Módosítva: {at}",
        change_moved: "{previous} helyett {current}",
        change_reason_line: "Indok: {reason}",
        change_withdrawn: "A műszak törölve (ez volt: {previous})",
        day_friday: "pén",
        day_monday: "hét",
        day_saturday: "szo",
        day_sunday: "vas",
        day_thursday: "csü",
        day_tuesday: "ked",
        day_wednesday: "sze",
        decline: "Nem tudom vállalni",
        decline_failed: "A választ nem sikerült rögzíteni.",
        decline_hint: "A beosztást készítő látni fogja, hogy nem tudod vállalni, és helyettesítést keres. A változás addig a listán marad, amíg ezt el nem rendezi.",
        decline_note: "Miért nem tudod vállalni? (nem kötelező)",
        decline_send: "Küldés",
        decline_title: "Ezt a műszakot nem tudom vállalni",
        declined: "Rögzítve: nem tudod vállalni.",
        duration_fixed_term: "Határozott idő",
        duration_indefinite: "Határozatlan idő",
        exempt_managing_person: "Vezető tisztségviselő",
        exempt_other: "Egyéb ok",
        free_day: "Szabadnap",
        load_failed: "Az adatokat nem sikerült beolvasni.",
        my_changes_title: "Vissza nem igazolt változások: {count}",
        my_pending_title: "Döntésre váró kérelmek: {count}",
        my_rota: "A beosztásom",
        my_rota_empty: "Ezen a héten nincs beosztott műszakod.",
        my_rota_empty_hint: "Amit itt látsz, az csak a közzétett beosztás. A beosztást készítő piszkozatait nem mutatja — amíg a hét nincs közzétéve, addig nem ígéret.",
        next_week: "Következő hét",
        no_swap_hint: "Ebben a portálban nincs műszakcsere kollégával és nincs helyettesítési kérelem sem. Ha egy műszakot nem tudsz vállalni, nyomd meg a „Nem tudom vállalni” gombot a fenti változásnál — a vezetőd azonnal látja, az indokkal együtt. Tervezett távollétre adj be szabadságkérelmet.",
        previous_week: "Előző hét",
        record_clock: "Bélyegzések",
        record_manual: "Kézi rögzítés",
        record_pattern: "Munkarend",
        record_schedule: "Beosztás",
        state_cancelled: "Törölve",
        state_draft: "Piszkozat",
        state_published: "Közzétéve",
        this_week: "Ez a hét",
        time_full: "Teljes munkaidő",
        time_part: "Részmunkaidő",
        today: "Ma",
        try_again: "Próbáld újra",
        unit_hours: "ó",
        unit_minutes: "p",
    },
    staff_absence: {
        days_recorded: "Nyilvántartott napok: {count}",
        decided_by_other: "A kérelmedről más dönt — a sajátodat nem hagyhatod jóvá.",
        from: "Kezdete",
        kind: "Típus",
        kind_business_trip: "Kiküldetés",
        kind_holiday: "Munkaszüneti nap",
        kind_other: "Egyéb",
        kind_sick_leave: "Táppénz",
        kind_training: "Képzés",
        kind_unexcused: "Igazolatlan távollét",
        kind_vacation: "Szabadság",
        my_absences: "A távolléteim",
        my_absences_hint: "A kérelmeid és a róluk született döntések. Az elutasítottak is láthatók maradnak — az elutasítás, amelyik eltűnik, meg sem történt.",
        no_my_requests: "Nincs távollétre vonatkozó kérelmed.",
        note: "Megjegyzés",
        other_kinds_hint: "Kérelmezni csak szabadságot lehet. A táppénzt a vezetődnek jelented, ő vezeti be a nyilvántartásba; a munkaszüneti nap a ház naptárából adódik; a képzés és a kiküldetés a munkáltató utasítása. Mindegyik megjelenik a nyilvántartásodban, amint bekerül.",
        other_kinds_title: "Egyéb távollétek",
        range_backwards: "A vége nem lehet a kezdete előtt.",
        range_too_long: "Egy kérelem legfeljebb {days} napra szólhat. Hosszabb távollétet a vezető rögzít.",
        request_hint: "Magadnak szabadságot kérhetsz. A táppénzt bejelented, és úgy kerül nyilvántartásba, a munkaszüneti nap a naptárból adódik, a képzést és a kiküldetést pedig a vezető rögzíti.",
        request_leave: "Szabadság kérelmezése",
        request_sent: "A kérelem döntésre elküldve.",
        send_request: "Kérelem küldése",
        source_calendar: "Ünnepnaptár",
        source_manager: "Vezetői rögzítés",
        source_request: "Kérelem",
        state_approved: "Jóváhagyva",
        state_rejected: "Elutasítva",
        state_requested: "Kérelmezve",
        state_withdrawn: "Visszavonva",
        to: "Vége",
        total_absence: "Távollét",
        withdraw: "Visszavonás",
        withdrawn: "A kérelem visszavonva.",
    },
    staff_document: {
        download: "Letöltés",
        expired_on: "Lejárt: {date}",
        expires_on: "Érvényes eddig: {date}",
        kind_aneks: "Szerződésmódosítás",
        kind_drugo: "Egyéb",
        kind_m1: "M-1 nyomtatvány",
        kind_nda: "Titoktartási nyilatkozat",
        kind_odlok: "Határozat",
        kind_pogodba: "Munkaszerződés",
        my_documents: "A dokumentumaim",
        my_documents_hint: "Amit a ház lefűzött hozzád. Te olvasod és letöltöd; lefűzni a ház fűz le.",
        no_my_documents: "Még nincs hozzád lefűzött dokumentum.",
        read_only_hint: "Itt nem lehet dokumentumot hozzáadni vagy törölni — a mappa a munkáltató nyilvántartása. Átvételi visszaigazolása csak a szabadságolási határozatnak van.",
    },
    staff_month: {
        badge_closed: "Lezárva",
    },
    staff_time: {
        break_counts_hint: "A szünet beleszámít a munkaidőbe, és nem vonjuk le.",
        break_short: "szünet {minutes}",
        correction_approved: "Jóváhagyva",
        correction_date: "Dátum",
        correction_decided_by_other: "A kérelemről más dönt — a sajátodat nem hagyhatod jóvá.",
        correction_hint: "Kérelmezni magad is tudod; dönteni más dönt.",
        correction_kind: "Bélyegzés típusa",
        correction_mode_existing: "Meglévő bélyegzés javítása",
        correction_mode_missing: "Hiányzó bélyegzés",
        correction_no_stamps: "Ezen a napon nincs javítható bélyegzés.",
        correction_reason: "Indok",
        correction_rejected: "Elutasítva",
        correction_requested: "Kérelmezve",
        correction_send: "Kérelem küldése",
        correction_sent: "A kérelem döntésre elküldve.",
        correction_time: "Idő",
        correction_what: "Mit javítasz",
        correction_which_stamp: "Melyik bélyegzést",
        day_open: "A nap nincs lezárva — nincs rögzített távozás.",
        decision_reason: "Indok: {reason}",
        excess_pending: "Többlet — besorolásra vár",
        first_in: "érkezés {at}",
        kind_break_end: "Szünet vége",
        kind_break_start: "Szünet",
        kind_clock_in: "Érkezés",
        kind_clock_out: "Távozás",
        last_out: "távozás {at}",
        month_pdf: "Havi kimutatás (PDF)",
        my_corrections: "Javítási kérelmeim",
        my_record: "A nyilvántartásom",
        my_time: "A saját órám",
        next_month: "Következő hónap",
        no_days: "Ebben az időszakban nincs rögzített nap.",
        of_which_break: "ebből szünet {minutes}",
        open: "Befejezetlen",
        period_month: "Hónap",
        period_week: "Hét",
        previous_month: "Előző hónap",
        queued: "Kapcsolatra vár: {count}",
        refused: "A bélyegzést nem fogadta el a rendszer.",
        not_recorded: "A bélyegzés nem került rögzítésre: {reason}",
        request_correction: "Javítás kérelmezése",
        stamped: "Rögzítve: {kind}",
        this_month: "Ez a hónap",
        today_total: "Ma",
        total_balance: "Egyenleg",
        total_break: "Szünet",
        total_expected: "Kötelező óraszám",
        total_worked: "Munka",
    },
    staff_vacation: {
        acknowledge: "Tudomásul veszem",
        acknowledge_hint: "A határozat ÁTVÉTELÉT igazolod vissza, nem azt, hogy egyetértesz a napok számával.",
        acknowledged: "Visszaigazolva",
        acknowledged_toast: "A határozat átvételét rögzítettük.",
        available: "Rendelkezésre áll",
        bucket_current: "Új",
        bucket_old: "Régi",
        current_leave: "{year}. évi szabadság",
        days_count: "{count} nap",
        decision_for_year: "{year}. évi határozat",
        decision_total: "Megállapítva: {days}",
        entitled: "Megállapítva",
        expired_days: "Lejárt {days} — a határidő {date} volt.",
        issued_at: "Kiállította: {who}, {at}",
        my_balance: "A szabadságom",
        my_decisions: "A határozataim",
        my_decisions_hint: "Az éves szabadság megállapításáról szóló határozatok, amelyeket a ház neked adott ki.",
        next_year: "Következő év",
        no_balance: "Erre az évre nincs szabadságadat.",
        no_balance_hint: "Az egyenleg akkor jön létre, ha kiadták a határozatot, és a személynek van érvényes munkavégzési időszaka.",
        no_my_decisions: "Neked még nem adtak ki határozatot.",
        no_usage: "Ebben az évben nincs rögzített szabadságfelhasználás.",
        not_acknowledged: "Nincs visszaigazolva",
        not_issued_hint: "Erre az évre még nem adtak ki határozatot.",
        of_which_pending: "Ebből döntésre vár: {days}",
        of_which_used: "Ebből felhasznált: {days}",
        old_leave: "Régi szabadság ({year})",
        over_remaining: "A kérelem meghaladja a rendelkezésre álló {days} napot. A döntés ettől függetlenül a házé.",
        part_base: "Alap",
        part_children: "Gyermekek",
        part_education: "Iskolai végzettség",
        part_full_year: "Összesen (teljes év)",
        part_responsibility: "Felelős munkakör",
        part_special: "Különleges kategória",
        part_tenure: "Munkaviszony ideje",
        pdf: "PDF",
        pending: "Döntés alatt",
        previous_year: "Előző év",
        requested_days: "Kért munkanapok: {days}",
        still_days: "még {days}",
        still_of: "még {left} / {total}",
        this_year: "Idén",
        usage_history: "Felhasználás előzményei",
        use_by: "Használd fel eddig: {date}.",
        used: "Felhasznált",
    },
    success: {
        add: "Sikeresen hozzáadva",
        edit: "Sikeresen frissítve",
    },
    validation: {
        email: "Érvénytelen e-mail-cím",
        required: "Ez a mező kötelező",
    },
}
